export default "__VITE_ASSET__Bg7_uhiZ__"